// import { t } from "i18next";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const SuccessPopupMsg = (props) => {
  // const ref = useRef(null);
  const closeAlert = props?.closeAlert

  const {t} = useTranslation();

  return (
    <div className="blur-screen-full-area flex-center">
      <div className="form-container  my-3">
        {/* <h3 className="text-bold text-center fs-3 mb-3">Success</h3> */}
        <div className="text-center m-4">{props?.message}</div>
        <div className=" flex-center">
          <button
            type="submit"
            className="theme-btn px-5 text-center w-75"
            style={{ }}
            onClick={()=>{closeAlert(false)}}
          >
            {t('Okay')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessPopupMsg;
